export const projects = [
  {
    id: 'agroflux',
    title: 'Agroflux',
    description:
      'Desenvolvedor Júnior contribuindo no desenvolvimento de plataformas web com foco em qualidade e aprendizado contínuo.',
    technologies: ['React', 'Docker', 'Next.js', 'MySQL', 'JavaScript', 'Postman', 'GitLab'],
    externalLinks: [{ externalName: 'Site', externalLink: 'https://www.agroflux.com.br/' }],
    category: 'Experiências',
    images: [{ name: 'palestra', file: '/imgs/imgsXP/agroflux/1.png' },
             { name: 'confraternizacao', file: '/imgs/imgsXP/agroflux/2.png' },]
  },          
  {
    id: 'perfil-news',
    title: 'Perfil News',
    description:
      'Atuação com social media e publicidade em portal de notícias, incluindo automações para edição de imagens em lote.',
    technologies: ['Adobe Photoshop', 'Sony Vegas Pro 13', 'Meta Business', 'WordPress'],
    externalLinks: [
      { externalName: 'Site', externalLink: 'https://www.perfilnews.com.br/' },
      { externalName: 'Instagram', externalLink: 'https://www.instagram.com/perfilnews/' },
    ],
    category: 'Experiências',
  },
  {
    id: 'carol-atelier',
    title: 'Carol Atelier System',
    description:
      'Sistema desktop para gestão de clientes, ativos, contratos, locações e relatórios, com treinamento e documentação.',
    technologies: ['Java', 'JasperReports', 'PostgreSQL', 'JavaFX'],
    externalLinks: [
      { externalName: 'Instagram', externalLink: 'https://www.instagram.com/atelierdasfestas_carol/' },
    ],
    category: 'Projetos',
  },
  {
    id: 'elaine-software',
    title: 'Elaine Software',
    description:
      'Software de gestão de despesas com cadastro de saídas, pagamentos e relatórios comparativos para organização financeira.',
    technologies: ['Java', 'JasperReports', 'H2 Database', 'JavaFX', 'Figma'],
    externalLinks: [
      { externalName: 'Instagram', externalLink: 'https://www.instagram.com/prixacademia/' },
      {
        externalName: 'Manual - ERS',
        externalLink: 'https://docs.google.com/document/d/1TjphPEAlf5vJP4N1S1gmpxQHOW1N9nJJbN_rovhXY68/edit?usp=sharing',
      },
    ],
    category: 'Projetos',
  },
  {
    id: 'mywebsite',
    title: 'myWebsite',
    description: 'Portfólio pessoal em React hospedado no GitHub Pages.',
    technologies: ['React', 'HTML', 'CSS', 'GitHub Pages'],
    externalLinks: [{ externalName: 'GitHub', externalLink: 'https://github.com/matchur/myWebsite' }],
    category: 'Projetos',
  },
  {
    id: 'doeja',
    title: 'DoeJá',
    description:
      'Projeto de incubação UTFPR para facilitar doações a entidades e pessoas em situação emergencial.',
    technologies: ['TypeScript', 'Insomnia', 'TypeORM', 'React', 'Docker', 'MongoDB', 'MySQL', 'Figma'],
    externalLinks: [
      { externalName: 'GitHub', externalLink: 'https://github.com/Hauagge/DoeJa' },
      { externalName: 'Site', externalLink: 'https://doeja.app/' },
    ],
    category: 'Projetos',
  },
  {
    id: 'carrinho-segue-linha',
    title: '1º Lugar: Carrinho Segue Linha',
    description:
      'Conquista, primeiro lugar na 3ª competição de carrinho segue linha durante o evento EmpreendeWeek.',
    technologies: ['Arduino', 'C++'],
    externalLinks: [],
    category: 'Atividades',
    images: [{ name: 'carrinho_protto', file: '/imgs/imgsXP/carrinho1/1.jpg' },
             { name: 'matheus_bruno', file: '/imgs/imgsXP/carrinho1/2.jpg' },
             { name: 'matheus_bruno2', file: '/imgs/imgsXP/carrinho1/3.jpg' },
             { name: 'medalha_1', file: '/imgs/imgsXP/carrinho1/4.jpg' },
    ],
  },
  {
    id: 'curso-programacao-de-jogos',
    title: 'Ministrante: Curso de Programação de Jogos',
    description:
      'Minicurso de 12 horas sobre desenvolvimento básico de jogos utilizando GameMaker Studio.',
    technologies: ['GameMaker Language (GML)'],
    externalLinks: [],
    category: 'Atividades',
  },
  {
    id: 'curso-kali-linux',
    title: 'Ministrante: Curso de Kali Linux',
    description:
      'Minicurso de 12 horas apresentando ferramentas do Kali Linux e práticas de verificação de segurança.',
    technologies: ['Kali Linux'],
    externalLinks: [],
    category: 'Atividades',
  },
  {
    id: 'masterpiece-manufacturing',
    title: 'Masterpiece Manufacturing',
    description:
      'Jogo educacional, cooperativo e online criado no programa de extensão Lúdico da UTFPR para ensinar processos de usinagem.',
    technologies: ['JavaScript', 'HTML', 'Phaser 3'],
    externalLinks: [
      { externalName: 'GitHub', externalLink: 'https://github.com/matchur/MasterpieceManufacturing' },
    ],
    category: 'Projetos',
  },
];